import { useState, useCallback } from 'react';
import { FileUploadState } from '../types';
import TalRevAPI, { handleApiError } from '../services/api';

export const useFileUpload = () => {
  const [uploadState, setUploadState] = useState<FileUploadState>({
    file: null,
    progress: 0,
    status: 'idle',
  });

  const uploadFile = useCallback(async (
    file: File,
    roleType?: 'individual_contributor' | 'manager',
    alias?: string
  ): Promise<string | null> => {
    setUploadState({
      file,
      progress: 0,
      status: 'uploading',
      error: undefined,
    });

    try {
      // Make API call with real progress tracking
      const result = await TalRevAPI.uploadTalentCard(file, (progress) => {
        setUploadState(prev => ({
          ...prev,
          progress,
        }));
      }, roleType, alias);

      // Upload complete
      setUploadState(prev => ({
        ...prev,
        status: 'success',
        progress: 100,
      }));

      return result.id;

    } catch (error) {
      const errorMessage = handleApiError(error);

      setUploadState(prev => ({
        ...prev,
        status: 'error',
        error: errorMessage,
      }));

      console.error('Upload failed:', error);
      return null;
    }
  }, []);

  const resetUpload = useCallback(() => {
    setUploadState({
      file: null,
      progress: 0,
      status: 'idle',
    });
  }, []);

  return {
    uploadState,
    uploadFile,
    resetUpload,
  };
};